import styled from 'styled-components';

import CommonGoogleAdsBanner from '~components/GoogleAdsBanner';
import { DESKTOP_WIDTH } from '~constant/layout';

export const Wrapper = styled.section`
  background-color: ${({ theme }) => theme.colors.gray200};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 30px auto 0;
  padding-bottom: 30px;
  max-width: ${DESKTOP_WIDTH}px;
  min-height: 366px;
  position: relative;
  box-sizing: content-box;

  ${({ theme }) => theme.media.tablet} {
    width: 100%;
    padding: 0 32px 30px;
    box-sizing: border-box;
  }

  ${({ theme }) => theme.media.mobile} {
    min-height: inherit;
    padding: 0;
    margin-top: 16px;
  }

  & > section {
    margin-bottom: 32px;

    ${({ theme }) => theme.media.mobile} {
      margin-bottom: 16px;
    }
  }
`;

export const Aside = styled.section`
  position: absolute;
  width: 310px;
  right: 0;
  top: 0;

  ${({ theme }) => theme.media.mobile} {
    position: relative;
    width: 100%;
    top: auto;
    right: auto;
  }
`;

export const GoogleAdsBanner = styled(CommonGoogleAdsBanner)`
  margin-left: 33px;

  ${({ theme }) => theme.media.with('mobile', 'tablet')} {
    width: 300px;
    margin: 0 auto;
  }
`;
